<template>
  <BbBtn
    v-if="count > 0"
    class="delete-all-button"
    size="small"
    type="secondary"
    :is-disabled="isLoading"
    @click="$emit('on-click')"
  >
    <BbIcon size="small" name="delete" />
    <TextBody i18n-key="common.delete" tag="div" />
    <span>{{ '(' + count + ')' }}</span>
  </BbBtn>
</template>

<script>
import TextBody from '~/components/common/TextBody.vue';

export default {
  components: { TextBody },
  props: {
    count: {
      type: Number,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['on-click'],
};
</script>

<style lang="scss" scoped>
.bb-btn.secondary.delete-all-button {
  border: 1px solid $bb-interface-5;
  width: 100%;

  :deep(.v-btn__content) {
    display: flex;
    gap: 2px;

    & > * {
      color: $bb-interface-5 !important;
    }
  }

  &:hover {
    background-color: inherit;
  }
}
</style>
